import { Component, EventEmitter, Injectable, Input, OnInit, Output, ViewChild } from '@angular/core';
import { BehaviorSubject, merge, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { FlatTreeControl } from '@angular/cdk/tree';
import { CollectionViewer, DataSource, SelectionChange } from '@angular/cdk/collections';
// @ts-ignore
import { folder_manager, template_manager } from '../assets/conf_urls.json';
import { map } from 'rxjs/operators';
import { TreeviewItem, TreeviewConfig, TreeviewHelper, TreeviewComponent } from 'ngx-treeview';
import { LoggerService } from 'src/shared/logger/logger.service';
import { Levels } from 'src/shared/logger/levels.enum';

/** Flat node with expandable and level information */
export class DynamicFlatNode {
  constructor(public item: string, public level = 1, public expandable = false,
    public isLoading = false, props?: any[],) {
  }
}

/**
 * Database for dynamic data. When expanding a node in the tree, the data source will need to fetch
 * the descendants data from the database.
 */
@Injectable({ providedIn: 'root' })
export class DynamicDatabase {
  dataMap = new Map<string, any[]>(
    [['UK', ['']]]
  );
  rootLevelNodes: string[] = [];

  setDatamap(item: any, array: any) {
    this.dataMap.set(item, array);
  }

  setRootLevel(item) {

    this.rootLevelNodes.push(item);
  }

  /** Initial data from database */
  initialData(): DynamicFlatNode[] {
    return this.rootLevelNodes.map(name => new DynamicFlatNode(name, 0, true));
  }

  getChildren(node: string): string[] | undefined {
    return this.dataMap.get(node);
  }

  isExpandable(node: string): boolean {
    return this.dataMap.has(node);
  }
}


export class DynamicDataSource implements DataSource<DynamicFlatNode> {

  dataChange = new BehaviorSubject<DynamicFlatNode[]>([]);

  get data(): DynamicFlatNode[] {
    return this.dataChange.value;
  }

  set data(value: DynamicFlatNode[]) {
    this._treeControl.dataNodes = value;
    this.dataChange.next(value);
  }

  constructor(private _treeControl: FlatTreeControl<DynamicFlatNode>,
    private _database: DynamicDatabase) {
  }

  connect(collectionViewer: CollectionViewer): Observable<DynamicFlatNode[]> {
    this._treeControl.expansionModel.changed.subscribe(change => {
      if ((change as SelectionChange<DynamicFlatNode>).added ||
        (change as SelectionChange<DynamicFlatNode>).removed) {
        this.handleTreeControl(change as SelectionChange<DynamicFlatNode>);
      }
    });

    return merge(collectionViewer.viewChange, this.dataChange).pipe(map(() => this.data));
  }

  disconnect(collectionViewer: CollectionViewer): void {
  }

  /** Handle expand/collapse behaviors */
  handleTreeControl(change: SelectionChange<DynamicFlatNode>) {
    if (change.added) {
      change.added.forEach(node => this.toggleNode(node, true));
    }
    if (change.removed) {
      change.removed.slice().reverse().forEach(node => this.toggleNode(node, false));
    }
  }

  /**
   * Toggle the node, remove from display list
   */
  toggleNode(node: DynamicFlatNode, expand: boolean) {
    const children = this._database.getChildren(node.item);
    const index = this.data.indexOf(node);
    if (!children || index < 0) { // If no children, or cannot find the node, no op
      return;
    }

    node.isLoading = true;

    setTimeout(() => {
      if (expand) {
        const nodes = children.map(name =>
          new DynamicFlatNode(name, node.level + 1, this._database.isExpandable(name)));
        this.data.splice(index + 1, 0, ...nodes);
      } else {
        let count = 0;
        for (let i = index + 1; i < this.data.length
          && this.data[i].level > node.level; i++, count++) {
        }
        this.data.splice(index + 1, count);
      }

      // notify the change
      this.dataChange.next(this.data);
      node.isLoading = false;
    }, 10);
  }
}


@Component({
  selector: 'app-treeview-systems',
  templateUrl: './treeview-systems.component.html',
  styleUrls: ['./treeview-systems.component.css'],

})



export class TreeviewSystemsComponent implements OnInit {
  //icons
  @Input() parent_icon: string;//
  @Input() child_icon: string;//

  //m2mtable

  @Input() title: string;//

  @Input() parent_table_name: string;//
  @Input() parent_table_pk: string;//
  @Input() parent_table_ref_value: string;//
  @Input() child_table_fk: string;//
  @Input() child_table_displayname: string;//
  @Input() child_table_name: string;//
  //one table tree params

  @Input() parent_table_group_key: string;//
  @Input() parent_table_display_value: string;//

  //end
  // tree by query
  @Input() query_tree: string;//
  @Input() aggr_table: string;//
  @Input() aggr_column: string;//
  @Input() display_value: string;//
  @Input() map_column: string;//
  //by url
  @Input() url: string;//


  //
  @Input() algorithm: string;//
  @Output() messageEvent = new EventEmitter<string>();//
  @Output() messageEvent_send_parent_information = new EventEmitter<string>();//
  @Output() messageEvent2 = new EventEmitter<{}>();//

  //ngx tree used inputs and outputs
  //input for ngx tree sort-by
  @Input() sort_by: string;
  @Input() has_checkbox = true;
  @Output() messageSelectedNode = new EventEmitter<{}>();
  @Output() messageSelectedMultipleNodes = new EventEmitter<{}>();
  @Output() messageSelectedMultipleNodesWithTheirText = new EventEmitter<{}>();
  @Output() messageSelectedFolder = new EventEmitter<{}>();
  @Output() messageResponseData = new EventEmitter<{}>();
  dropdownEnabled = true;
  items: TreeviewItem[];
  items_json: any;
  values: number[];
  config = TreeviewConfig.create({
    hasAllCheckBox: this.has_checkbox,
    hasFilter: true,
    hasCollapseExpand: true,
    decoupleChildFromParent: false,
    maxHeight: 500
  });

  show_progressbar = false;

  selected_items: any;
  single_item_selected: any;

  node_click_style_value = "";

  treeControl: FlatTreeControl<DynamicFlatNode>;
  dataSource: DynamicDataSource;
  getLevel = (node: DynamicFlatNode) => node.level;
  isExpandable = (node: DynamicFlatNode) => node.expandable;
  hasChild = (_: number, _nodeData: DynamicFlatNode) => _nodeData.expandable;

  constructor(private database: DynamicDatabase,
    private http: HttpClient,
    private loggerService: LoggerService) {
    this.treeControl = new FlatTreeControl<DynamicFlatNode>(this.getLevel, this.isExpandable);
    this.dataSource = new DynamicDataSource(this.treeControl, this.database);
    this.dataSource.data = this.database.initialData();
  }

  ngOnInit(): void {
    //this.get_tree()
    //this.get_ngx_tree(this.sort_by)
    //this.reload_treeView()
  }

  node_click_style(node: TreeviewItem) {
    if (this.node_click_style_value === node.value) {
      return "color:black; font-weight: bold; font-size: 14px;"
    }
    else {
      return ""
    }
  }

  set_node_click_style_value(node: TreeviewItem) {
    if (this.node_click_style_value === node.value) {
      this.node_click_style_value = ""
      return
    }
    this.node_click_style_value = node.value
  }

  bkground_color(node: TreeviewItem) {
    if (node.checked) {
      return "color:black; font-weight: bold; font-size: 14px;"
    }
    else {
      return ""
    }
  }

  log_item(item: any) {
  }




  onSelection(iw: any) {
    this.messageSelectedFolder.emit(iw)
    if (iw["expandable"] == true) {
      this.get_folder_id_emit(iw)

    } else {
      this.messageEvent2.emit(iw)
    }
  }

  //
  get_folder_id_emit(node) {
    this.show_progressbar = true;

    this.http.post(folder_manager.get_folder_id_by_name, {
      'event': 'query',
      'item_name': node['item']
    }).subscribe(response => {
      this.show_progressbar = false;
      this.single_item_selected = { 'id': response[0]['id'], 'item_name': response[0]['item_name'] };
      this.messageEvent_send_parent_information.emit(this.single_item_selected)
      this.messageEvent2.emit(this.single_item_selected)
    });
  }

  reload_treeView() {

    setTimeout(() => {
      let element: HTMLElement = document.getElementsByClassName('nav-link')[0] as HTMLElement;
      element.click();

    }, 700)
  }

  refreshFlag: boolean = true;
  get_ngx_tree(sort_by) {
    if (sort_by && this.refreshFlag) {
      this.refreshFlag = false;
      var json_body = { 'group_by': sort_by }
      this.items = [];
      this.http.post(folder_manager.ngx_tree, json_body).subscribe(data => {
        this.refreshFlag = true;
        this.show_progressbar = false
        this.items_json = data['tree'];
        if (typeof (this.items_json) == 'object') {
          this.items_json.forEach(item => {
            this.items.push(new TreeviewItem(item));
          });
        }

      }, err => {
        this.loggerService.log("TreeviewSystemsComponent", err.message, Levels.error);
        this.refreshFlag = true;
      });
    }
  }

  ngOnChanges() {
    /**********THIS FUNCTION WILL TRIGGER WHEN PARENT COMPONENT UPDATES 'sort_by'**************/
    this.get_ngx_tree(this.sort_by);
    this.config.hasAllCheckBox = this.has_checkbox
  }


  onFilterChange(value: string) {
  }

  @ViewChild(TreeviewComponent) treeView: TreeviewComponent;
  onSelectedChange(node: TreeviewItem[]) {
    //this.treeView.selection.checkedItems.forEach(item=>item.correctChecked())
    let nodesToBeSentWithTheirValuesAndText = [];
    //this array is mainly to bulk delete to have each item in tree with its text and id only
    // console.log(this.treeView);
    // console.log(this.items);

    this.treeView.selection.checkedItems.forEach(item => {
      if (item.value?.type == "endpoint") {
        nodesToBeSentWithTheirValuesAndText.push({ text: item.text, value: item.value?.id })
      }
    })
    this.messageSelectedMultipleNodesWithTheirText.emit(nodesToBeSentWithTheirValuesAndText)
    this.messageSelectedMultipleNodes.emit(node)
  }


  onSelection_new(item: any) {

    if (item.value["type"] == "endpoint" || item.value["type"] == "template_job") {
      if (this.sort_by == "folder" || this.sort_by == "template_jobs") {
        for (const root_item of this.items) {
          if (TreeviewHelper.findParent(root_item, item)) {
            //this.messageSelectedFolder.emit(TreeviewHelper.findParent(root_item, item))
            item.value["parent"] = TreeviewHelper.findParent(root_item, item)
          }
        }
      }
      this.messageSelectedNode.emit(item)
    } else if (item.value["type"] == "folder" && this.sort_by == "folder") {
      this.messageSelectedFolder.emit(item)
      // console.log("iw", item)

    }
  }

}
